import React, { useState } from "react";
import { Button } from "../ui/button";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { ResetDemoModal } from "./ResetDemoModal";

export function DangerZonePanel() {
  const [open, setOpen] = useState(false);

  const onSuccess = () => {
    // Hard reload so all panels refetch (and any stale lists clear).
    setTimeout(() => window.location.reload(), 800);
  };

  return (
    <div
      data-testid="danger-zone-panel"
      className="mt-12 rounded-2xl border-2 border-[#FECACA] bg-[#FEF2F2] p-6 shadow-sm"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-[#FEE2E2] flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-6 h-6 text-[#B91C1C]" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-xl text-[#7F1D1D]">Zone dangereuse</h3>
          <p className="text-sm text-[#991B1B] mt-1 font-medium">
            Remise à zéro de la plateforme — irréversible
          </p>
          <p className="text-sm text-[#7F1D1D] mt-3 leading-relaxed">
            Cette action supprime définitivement toutes les données opérationnelles de la plateforme :
            leads, commerçants, licenciés, collaborateurs, invitations, password resets, audit logs et statistiques.
            Seul votre compte admin sera conservé. <strong>Cette action est irréversible.</strong>
          </p>
        </div>
      </div>

      <div className="mt-5 flex items-center justify-end">
        <Button
          type="button"
          onClick={() => setOpen(true)}
          data-testid="danger-zone-reset-btn"
          className="rounded-lg bg-[#B91C1C] hover:bg-[#991B1B] text-white font-semibold shadow-[0_4px_14px_rgba(185,28,28,0.25)]"
        >
          <RotateCcw className="w-4 h-4 mr-2" />
          Réinitialiser la plateforme
        </Button>
      </div>

      <ResetDemoModal open={open} onOpenChange={setOpen} onSuccess={onSuccess} />
    </div>
  );
}

export default DangerZonePanel;
